// api
import apiRequest from 'api/restapi';
import { AxiosResponse } from 'axios';
import qs from 'qs';

const getStory = (url: string): Promise<AxiosResponse<any>> => {
  const queryString = qs.stringify({ url });

  return apiRequest.get(`/RealStoryArticle/by-url?${queryString}`);
};

const getStories = (
  forHomePage?: boolean,
  forServicePage?: boolean,
  categories?: string[],
  serviceId?: string,
): Promise<AxiosResponse<any>> => {
  const queryString = qs.stringify({ isPublished: true, forHomePage, forServicePage, categories, serviceId, limit: 12 });

  return apiRequest.get(`/RealStoryArticle?${queryString}`);
};

export default { getStory, getStories };
